export const Responsibilities = [
  {
    title:
      "You will only use the account for your sole, personal use and will not resell it to a third party;",
  },
  {
    title:
      "You will adhere to the “Terms of Use” and “Privacy Policy” at all times;",
  },
  { title: "You will not authorize others to use your account;" },
  {
    title:
      "You will not assign or otherwise transfer your account to any other person or legal entity;",
  },
  {
    title:
      "You will not use an account that is subject to any rights of a person other than you without appropriate authorization;",
  },
  {
    title:
      "You will not use the Service for unlawful purposes, including but not limited to sending or storing any unlawful material or for fraudulent purposes;",
  },
  {
    title:
      "You will not use the Service or Application to cause nuisance, annoyance or inconvenience;",
  },
  {
    title:
      "You will not impair the proper operation of the network and not try to harm the Service or Application in any way whatsoever;",
  },
  {
    title:
      "You will keep secure and confidential your account password or any identification we provide you which allows access to the Service;",
  },
  {
    title:
      "You will provide us with whatever proof of identity we may reasonably request;",
  },
  {
    title:
      "You will not disable, tamper with or otherwise attempt to circumvent any billing mechanism that meters the use of the Website and App by you or any other person under your guidance or influence;",
  },
  {
    title:
      "You will not use the Website and App in any way that could damage our reputation or goodwill, or other rights associated with the Connect2MyDoctor or Neev Tech Labs brand or health platform;",
  },
  {
    title:
      "You will not attempt to secure unauthorised access to any materials other than those to which you have been given explicit authorization.",
  },
  {
    title:
      "You will comply with all applicable law from your home nation, the country, state and/or city in which you are present while using the Service.",
  },
  {
    title:
      "You will comply with all applicable law from your home nation, the country, state and/or city in which you are present while using the Service.",
  },
  {
    title:
      "You will not transmit, or input into the Website and Apps any information, data, files or other material that may damage any other person's computing devices or software, may be offensive, or which is in violation of any law (including material protected by copyright or trade secrets which you do not have the right to use);",
  },
  {
    title:
      "You will not attempt to modify, copy, adapt, reproduce, disassemble, decompile or reverse engineer any computer programs or applications used to deliver or operate the service.",
  },
  {
    title:
      "You will not use any automated processes/bots/internet links or any means to access the Website and App that may cause stress to the regular working of the website and app",
  },
  {
    title:
      "You will not send or store infringing, obscene, threatening, libellous, or otherwise unlawful or tortious material, including material harmful to children or violate of third party privacy rights;",
  },
];

export const refund = [
  { title: "100% refund to the patient if Doctor cancels the appointment." },
  {
    title:
      "100% refund to the patient if they cancel within 72 hours prior to the appointment",
  },
  {
    title:
      "80% refund to the patient if they cancel within 24-72 hours prior to the appointment.",
  },
];

export const Links = [
  {
    title:
      "You may link to our home page, provided you do so in a way that is fair and legal and does not damage our reputation or take advantage of it.",
  },
  {
    title:
      "You must not establish a link in such a way as to suggest any form of association, approval or endorsement on our part where none exists.",
  },
  {
    title:
      "You must not establish a link to our Site in any website that is not owned by you.",
  },
  {
    title:
      "Our Site must not be framed on any other site, nor may you create a link to any part of our Site other than the home page.",
  },
  {
    title:
      "We reserve the right to withdraw linking permission without notice.",
  },
  {
    title:
      "The website in which you are linking must comply in all respects with our content standards.",
  },
  {
    title:
    <span>If you wish to link to or make any use of content on our Site other than that set out above, please contact  <a href="mailto:support@connect2my.doctor">support@connect2my.doctor</a>.</span>
        
  },
];
